import Label, { LabelColor } from '@/components/core/label';
import { ChoicesOrderStatus } from '@/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface OrderStatusLabelProps {
  status: ChoicesOrderStatus;
}

export const OrderStatusLabel: FC<OrderStatusLabelProps> = ({ status }) => {
  const { t } = useTranslation();
  const statusColors: Record<ChoicesOrderStatus, LabelColor> = {
    [ChoicesOrderStatus.created]: 'default',
    [ChoicesOrderStatus.pendingApproval]: 'secondary',
    [ChoicesOrderStatus.pendingProvision]: 'warning',
    [ChoicesOrderStatus.provisioning]: 'warning',
    [ChoicesOrderStatus.failedProvision]: 'error',
    [ChoicesOrderStatus.completed]: 'success',
    [ChoicesOrderStatus.rejected]: 'error',
    [ChoicesOrderStatus.cancelled]: 'error',
  };

  const statusLabels: Record<ChoicesOrderStatus, string> = {
    [ChoicesOrderStatus.created]: t('Draft'),
    [ChoicesOrderStatus.pendingApproval]: t('Pending Approval'),
    [ChoicesOrderStatus.pendingProvision]: t('Pending Provision'),
    [ChoicesOrderStatus.provisioning]: t('Provisioning'),
    [ChoicesOrderStatus.failedProvision]: t('Failed Provision'),
    [ChoicesOrderStatus.completed]: t('Completed'),
    [ChoicesOrderStatus.rejected]: t('Rejected'),
    [ChoicesOrderStatus.cancelled]: t('Cancelled'),
  };

  return (
    <Label variant="soft" color={statusColors[status] || 'default'}>
      {statusLabels[status] || t('Unknown')}
    </Label>
  );
};
